<form [formGroup]="form" class="additional-services-step">
  <p class="additional-services-intro">{{ introText }}</p>

  <section class="additional-services-group">
    <h3>{{ groupCommunityHeading }}</h3>
    <p class="additional-services-group-prompt">{{ groupCommunityPrompt }}</p>

    <app-quantity-stepper
      [control]="form.controls.communityVisitsQty"
      [label]="communityVisitsLabel"
      [max]="8"
    />
    <app-quantity-stepper
      [control]="form.controls.travelQty"
      [label]="travelLabel"
    />

    <p class="additional-services-warning-banner" *ngIf="showTravelWarning">
      {{ travelWarningMessage }}
    </p>
  </section>

  <section class="additional-services-group">
    <h3>{{ groupTeamHeading }}</h3>

    <app-quantity-stepper
      [control]="form.controls.collaborativeCareCfssQty"
      [label]="collaborativeCareCfssLabel"
    />
    <app-quantity-stepper
      [control]="form.controls.collaborativeCareAudQty"
      [label]="collaborativeCareAudLabel"
    />
  </section>

  <section class="additional-services-group">
    <h3>{{ groupSpeechHeading }}</h3>

    <app-quantity-stepper
      [control]="form.controls.additionalCommunicationAssessmentQty"
      [label]="additionalCommunicationAssessmentLabel"
    />
    <app-toggle-button
      [control]="form.controls.startingSchoolReport"
      [label]="startingSchoolReportLabel"
    />
    <app-toggle-button
      [control]="form.controls.socialEmotionalAssess"
      [label]="socialEmotionalAssessLabel"
    />
  </section>

  <section class="additional-services-group">
    <h3>{{ groupHearingHeading }}</h3>
    <p class="additional-services-group-prompt">{{ groupHearingPrompt }}</p>

    <app-toggle-button
      [control]="form.controls.annualSpeechPerception"
      [label]="annualSpeechPerceptionLabel"
    />
    <p class="additional-services-hint">{{ annualSpeechPerceptionHint }}</p>
    <app-toggle-button
      [control]="form.controls.speechPerceptionTesting"
      [label]="speechPerceptionTestingLabel"
    />

    <app-textarea
      *ngIf="requiresAnnualSpeechPerceptionReason"
      [control]="form.controls.annualSpeechPerceptionReason"
      [label]="annualSpeechPerceptionReasonLabel"
      [required]="requiresAnnualSpeechPerceptionReason"
      [errorText]="
        'SERVICE_PLAN.VALIDATION.ANNUAL_SPEECH_PERCEPTION_REASON_REQUIRED'
          | translate
      "
    />
  </section>

  <section class="additional-services-group">
    <h3>{{ groupGroupsHeading }}</h3>

    <app-toggle-button
      [control]="form.controls.talkTogether"
      [label]="talkTogetherLabel"
    />
  </section>

  <app-textarea
    *ngIf="showBookingTiming"
    [control]="form.controls.bookingTiming"
    [label]="bookingTimingLabel"
    [required]="true"
    [errorText]="
      'SERVICE_PLAN.VALIDATION.BOOKING_TIMING_REQUIRED' | translate
    "
  />
</form>
